// 1. 核心：导入 axios
import axios from 'axios'
// 2. 导入 Vue（因为用到了 Vue.prototype）
import Vue from 'vue'
import {Message} from 'element-ui'

let router = () => import(`../../${process.env.PROJECT_NAME}/router/index.js`)


// 响应时间
axios.defaults.timeout = 1000*120;
// 配置请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 静态资源
Vue.prototype.$static = '';

// POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(
  config => {
    if (config.method === 'post') {
      //config.data = qs.stringify(config.data);
      //config.headers.post['Content-Type'] = 'application/json';
      //4hHE1+2YrnDt9Hkm0RiC3Ac3Nsw3wnbzf8gwIjiL+CE=
    }
    let path = window.location.search.split('?')[1];
    if(path){
      if(path.split('=')[0]=='token'||path.split('=')[0]=='tk'){
        let token = decodeURIComponent(path.split('=')[1]);
        sessionStorage.setItem('token',token);
        config.headers.token = token;
      }else{
        config.headers.token = sessionStorage.getItem("token");
      }
    }else{
      config.headers.token = sessionStorage.getItem("token");
    }
    return config
  },
  err => {
    Message.error('请求错误');
    return Promise.reject(err)
  }
);
// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  res => {
    if (res.status === 200) {
      return res;
    }
  },
  error => {
    let errMsg = error.toString();
    let code = errMsg.substr(errMsg.indexOf('code') + 5);
    /*Message({
      message: errorCode[code] || errorCode['default'],
      type: 'error'
    });*/
    switch(error.request.status){
      case 401:
        Message.error('您的账号暂未授权');
        sessionStorage.clear();
        localStorage.clear();
        if(process.env.PROJECT_NAME == 'civillan'){
          window.location.href = 'https://www.gcycloud.com/'
        }else if(process.env.PROJECT_NAME == 'testing'){
          window.location.href = "http://47.110.56.138:9800/"
        }
        break;
      case 500:
        Message.error('服务器繁忙，请稍后访问');
        break;
    }

    return Promise.reject(err)
  }
);
// 发送请求
export function post (url, params) {
  var responseType = ''
  if(url=='/api/data/export/recordDynamicExport'){
    responseType='blob'
  }else if(url=='/foreground/history/editHistory'){
    axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
  }else{
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
  }
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, {
        responseType: responseType
      })
      .then(
        res => {
          resolve(res.data);
        },
        err => {
          reject(err.data)
        }
      )
      .catch(err => {
        reject(err.data)
      })
  })
}
export function get (url, params ,responseType) {
  if(url=='/api/data/export/recordExport'||url=='/foreground/cfg/export'||url=='/api/data/warn/exportWarn'){
    responseType='blob'
  }
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
        responseType:responseType
      })
      .then(res => {
        if(url == '/api/project/findProjectByUser'){
          if(res.data.result.length > 1){
            res.data.result = [{
              projectChildrenList: res.data.result
            }]
          }
        }
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}



// WEBPACK FOOTER //
// ./src/comm/axiosconfig/axiosConfig.js